import router, { routes as _routes } from '@iez/core/router'

export default ({ pages }) => {
  /**
   * Router
   */
  const routes = Array.from(Object.values(pages)).map(({ name, path, auth, ...component }) => ({
    name,
    path,
    auth,
    component,
    props: true
  }))
  routes.forEach(route => {
    router.addRoute(route)
  })
  _routes.push(...routes)
  /* routesAuth.push(
    ...routes
      .filter(({ auth }) => !!auth)
      .map(({ name }) => name)
  ) */

  return router
}
